export enum ListFormatType {
  Comma = 1,
  NewLine = 2,
}